<template>
  <IndicatorsWrapper v-if="summary" :list="indicatorsListFilter" title="Инвестиции" source="ЮНКТАД">
    <template #item="{ item }">
      <p class="text-align-left fs14 fw600 mb-6">{{ item.title }}</p>
      <div class="d-flex align-items-center">
        <strong class="fs22 fw700 mr-8">
          {{ item.count == 0 ? '-' : item.count }}
        </strong>
        <div>
          <div class="fs12">млн $</div>
        </div>
      </div>
      <!-- <div class="award" v-if="item.awards">
            <p>1 место - {{summary.inFlowsLeaderCountry}}</p>
            <p>{{summary.inFlowsRussiaPlace}} место - Россия
              <span v-if="summary.inFlowsRussiaValue">({{summary.inFlowsRussiaValue.toFixed(2)}})</span></p>
          </div> -->
    </template>
    <template #footer>
      <span class="suggestion" v-if="summary.prevYear > 0"
        >Данные за {{ year }} год не опубликованы, приведены данные за {{ summary.prevYear }} год</span
      >
      <span
        class="suggestion"
        v-if="summary.inFlows == 0 && summary.outFlows == 0 && summary.inStock == 0 && summary.outStock == 0"
        >Данные отсутствуют</span
      >
    </template>
  </IndicatorsWrapper>
</template>

<script>
  import text from '@/common/mixins/text';

  import Api from '../../api';
  import IndicatorsWrapper from '../IndicatorsWrapper.vue';

  export default {
    name: 'InvestmentsWorldEconRev',
    mixins: [text],
    components: {
      IndicatorsWrapper,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
      year: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        summary: null,
        indicatorsList: [],
      };
    },
    computed: {
      indicatorsListFilter() {
        return this.indicatorsList.filter((item) => item.count != '');
      },
    },
    created() {
      this.loadSummary();
    },
    methods: {
      loadSummary() {
        Api.getInvestmentSummary(this.countryId, this.year).then((response) => {
          this.summary = response.data;

          this.indicatorsList = [
            {
              id: 1,
              title: 'Входящие ПИИ,\n' + 'запас',
              count: this.formatNumber(this.summary.inStock, 0),
              period: this.summary.investmentPosition?.year,
            },
            {
              id: 2,
              title: 'Исходящие ПИИ,\n' + 'запас',
              count: this.formatNumber(this.summary.outStock, 0),
              period: this.summary.investmentPosition?.year,
            },
            {
              id: 3,
              title: 'Входящие ПИИ,\n' + 'поток',
              count: this.formatNumber(this.summary.inFlows, 0),
              awards: true,
              period: this.summary.investmentPosition?.year,
            },
            {
              id: 4,
              title: 'Исходящие ПИИ,\n' + 'поток',
              count: this.formatNumber(this.summary.outFlows, 0),
              period: this.summary.investmentPosition?.year,
            },
            {
              id: 5,
              title: 'Международная\n' + 'инвестиционная позиция',
              count: this.formatNumber(this.summary.investmentPosition?.value, 0),
              period: this.summary.investmentPosition?.year,
            },
          ];
        });
      },
    },
    watch: {
      countryId: function () {
        this.loadSummary();
      },
      year: function () {
        this.loadSummary();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .suggestion {
    font-size: 14px;
  }
</style>
